import { Link, useNavigate } from "react-router";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { fetchJson } from "../../utils";
import { useAppState } from "../../context";
import { UserType } from "../../types";
import PopularVideoStories from "../../blocks/pupular-video-stories";

type Inputs = {
    identity: string
    credential: string
}
type SignInResponse = {
    success: boolean;
    user?: UserType;
    field?: keyof Inputs;
    message?: string;
};

type SignInProps = {
    redirectTo?: string
}

export const SignIn = ({
    redirectTo = '/account'
}: SignInProps) => {

    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const [, setUser] = useAppState<UserType>('user');
    const {
        register,
        handleSubmit,
        formState: { errors },
        setError
    } = useForm<Inputs>();

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        setSubmitting(true);

        try {
            const { json } = await fetchJson<SignInResponse>("/api/sign-in", {
                method: "POST",
                body: JSON.stringify({
                    ...data,
                    remember_me: true,
                }),
            });

            if (json.success && json.user) {
                setUser(json.user);
                navigate(redirectTo);
            } else if (!json.success && json.field && json.message) {
                setError(json.field, {
                    type: "manual",
                    message: json.message
                });
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <section className="section">
                <div className="inside-wrapper">
                    <h1 className="section__title">
                        Login
                    </h1>
                    <div className="signbox">
                        <div className="signbox__form form">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`form__row ${errors.identity && 'is-error'}`}>
                                    <label className="form__label">
                                        Email Address
                                    </label>
                                    <div className="form__input-holder">
                                        <input type="identity" className="form__input" {...register('identity', {
                                            required: 'Email is required',
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: 'Invalid email address'
                                            }
                                        })} />
                                    </div>
                                    {errors.identity && <div className="form__alert">{errors.identity.message}</div>}
                                </div>
                                <div className={`form__row ${errors.credential && 'is-error'}`}>
                                    <label className="form__label">
                                        Password
                                    </label>
                                    <div className="form__input-holder">
                                        <input type="password" className="form__input" {...register('credential', {
                                            required: 'Password is required',

                                        })} />
                                    </div>
                                    {errors.credential && <div className="form__alert">{errors.credential.message}</div>}
                                </div>
                                <div className="form__row form__row_extragap form__note">

                                    <Link to="/password-reset">Forgot my password</Link>
                                </div>
                                <div className="form__row form__row_smallgap form__btns">
                                    <button className="btn btn_cta btn_lg btn_extrapad" type="submit" disabled={submitting}>Continue</button>
                                </div>
                                <div className="form__row form__row_smallgap form__note">
                                    You don&rsquo;t have an&nbsp;account? &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <Link to="/sign-up">Sign&nbsp;Up</Link>
                                </div>
                            </form>
                        </div>
                        <div className="signmore">
                            <div className="signmore__label">
                                <div className="signmore__label-text">OR</div>
                            </div>
                            <div className="signmore__btns">
                                <a href={`/auth/google?return=${redirectTo}`} className="btn btn_sign">
                                    <img src="./img/s_google.svg" className="btn__sign-ico" alt="Google" />
                                    Sign In with Google
                                </a>
                                <a href={`/auth/facebook?return=${redirectTo}`} className="btn btn_sign">
                                    <img src="./img/s_facebook.svg" className="btn__sign-ico" alt="Facebook" />
                                    Sign In with Facebook
                                </a>
                                <a href={`/auth/microsoft?return=${redirectTo}`} className="btn btn_sign">
                                    <img src="./img/s_microsoft.svg" className="btn__sign-ico" alt="Microsoft" />
                                    Sign In with Microsoft
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <PopularVideoStories />
        </>
        )
}

export default SignIn;